<script>
import {
  BCard, BCardBody, BButton, BCardHeader,
} from 'bootstrap-vue'
import ColorPicker from '@/components/settings-ecommecer/ColorPicker.vue'
import { useApiAWS } from '@/composables/useApi'
import axios from '@axios'
const api = useApiAWS()
export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    ColorPicker,
    BCardHeader,
  },
  data() {
    const maxSizeEnv = Number(process.env.VUE_APP_IMAGE_MAX_SIZE_MB)
    const maxImageSizeMb = Number.isFinite(maxSizeEnv) && maxSizeEnv > 0 ? maxSizeEnv : 5

    return {
      formSettings: {
        logo_footer: 'https://dkpsales.s3.sa-east-1.amazonaws.com/logos_header_footer/1_png',
        logo_header: 'https://dkpsales.s3.sa-east-1.amazonaws.com/logos_header_footer/1_png',
        cor_principal: '#000',
        cor_secundaria: '#000',
      },
      maxImageSizeMb,
      maxImageSize: maxImageSizeMb * 1024 * 1024,
      maxImageDimension: 1920,
      compressionQuality: 0.92,
      allowedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
      isUpdate: false,
    }
  },
  computed: {
    userData() {
      return this.$store.getters['auth/getUserData']
    },
  },
  watch: {
    formSettings: {
      handler() {
        this.updateCondig()
      },
      deep: true,
    },
  },
  methods: {
    showFileWarning(message) {
      window.alert(message)
    },
    validateImageType(file) {
      return this.allowedImageTypes.includes(file.type)
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const objectUrl = URL.createObjectURL(file)

        image.onload = () => {
          URL.revokeObjectURL(objectUrl)
          resolve(image)
        }

        image.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Não foi possível ler a imagem selecionada.'))
        }

        image.src = objectUrl
      })
    },
    canvasToFile(canvas, file, mimeType, quality) {
      return new Promise(resolve => {
        canvas.toBlob(blob => {
          if (!blob) {
            resolve(file)
            return
          }

          resolve(new File([blob], file.name, {
            type: mimeType,
            lastModified: file.lastModified,
          }))
        }, mimeType, quality)
      })
    },
    hasTransparency(context, width, height) {
      const { data } = context.getImageData(0, 0, width, height)

      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) {
          return true
        }
      }

      return false
    },
    async compressImage(file) {
      if (file.type === 'image/gif') {
        return file
      }

      const image = await this.loadImage(file)
      const needsResize = image.width > this.maxImageDimension || image.height > this.maxImageDimension
      const needsCompress = file.size > this.maxImageSize

      if (!needsResize && !needsCompress) {
        return file
      }

      const scale = Math.min(
        this.maxImageDimension / image.width,
        this.maxImageDimension / image.height,
        1,
      )
      const width = Math.max(1, Math.round(image.width * scale))
      const height = Math.max(1, Math.round(image.height * scale))
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height

      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, width, height)

      const isPng = file.type === 'image/png'
      const mimeType = isPng && this.hasTransparency(context, width, height)
        ? 'image/png'
        : 'image/jpeg'
      const quality = mimeType === 'image/jpeg' ? this.compressionQuality : undefined

      const compressedFile = await this.canvasToFile(canvas, file, mimeType, quality)

      if (compressedFile.size >= file.size) {
        return file
      }

      return compressedFile
    },
    async prepareImage(file) {
      if (!this.validateImageType(file)) {
        this.showFileWarning('Selecione apenas imagens JPEG, PNG ou GIF.')
        return null
      }

      const compressedFile = await this.compressImage(file)

      if (compressedFile.size > this.maxImageSize) {
        this.showFileWarning(`A imagem ainda ficou acima de ${this.maxImageSizeMb}MB após a compressão automática.`)
        return null
      }

      return compressedFile
    },
    updateCondig() {
      axios.put(`/config/${this.formSettings.id}`, this.formSettings)
    },
    async handleFileUpload(event, type) {
      const file = event.target.files[0]
      if (!file) return

      const preparedFile = await this.prepareImage(file)
      if (!preparedFile) return

      const formData = new FormData()
      formData.append('image', preparedFile)
      formData.set('caminho', 'logos_header_footer')
      api.post('/upload', formData)
        .then(response => {
          if (type === 'header') {
            this.formSettings.logo_header = response.data.image_url
          } else {
            this.formSettings.logo_footer = response.data.image_url
          }
          this.updateCondig()
        })
        .catch(error => {
          console.error(error)
        })
    },
    getKeyUrl(url) {
      return url.replace('https://dkplayer.s3.sa-east-1.amazonaws.com/', '')
    },
    deleteLogo(type, isUpdate= false) {
      api.delete('/delete', {
        data: {
          file_key: type === 'header' ? this.getKeyUrl(this.formSettings.logo_header) : this.getKeyUrl(this.formSettings.logo_footer),
        },
      })
        .then(() => {
          if (isUpdate) return
          if (type === 'header') {
            this.formSettings.logo_header = 'https://dkpsales.s3.sa-east-1.amazonaws.com/logos_header_footer/1_png'
          } else {
            this.formSettings.logo_footer = 'https://dkpsales.s3.sa-east-1.amazonaws.com/logos_header_footer/1_png'
          }
          this.updateCondig()
        })
        .catch(error => {
          console.error(error)
        })
    },
  },
  mounted() {
    axios.get(`/config/cliente/${this.userData.cliente.uuid}`)
      .then(response => {
        this.formSettings = response.data
      })
      .catch(error => {
        console.error(error)
      })
  },
}
</script>

<template>
  <div class="row match-height">
    <div class="col-md-4 text-center">
      <b-card>
        <b-card-header>
          <h3>Logo Header</h3>
        </b-card-header>
        <b-card-body class="row text-center">
          <input
            id="upload_file_header"
            hidden
            type="file"
            accept="image/*"
            @change="handleFileUpload($event, 'header')"
          >
          <label
            for="upload_file_header"
            class="col-12"
          >
            <img
                :style="{ backgroundColor: formSettings.cor_principal }"
              width="250"
              :src="formSettings.logo_header"
              alt="Logo Header"
            >
          </label>
          <div
            class="col-12 mt-2 d-flex justify-content-center"
            style="gap: 10px"
          >

            <b-button
              variant="danger"
              @click="deleteLogo('header')"
            >
              Delete
            </b-button>
          </div>

        </b-card-body>
      </b-card>
    </div>
    <div class="col-md-4">
      <b-card>
          <strong>Cor Principal</strong>
        <b-card-body>
          <color-picker v-model="formSettings.cor_principal" />
        </b-card-body>
      </b-card>
      <b-card>
          <strong>Cor Secundária</strong>
        <b-card-body>
          <color-picker v-model="formSettings.cor_secundaria" />
        </b-card-body>
      </b-card>
    </div>

    <div class="col-md-4 text-center" v-if="$can('manage', 'all')">
      <b-card>
        <b-card-header>
          <h3>Logo Footer</h3>
        </b-card-header>
        <b-card-body class="row text-center">
          <input
              id="upload_file_footer"
              hidden
              type="file"
              accept="image/*"
              @change="handleFileUpload($event, 'footer')"
          >
          <label
              for="upload_file_footer"
              class="col-12"
          >
            <img
                :style="{ backgroundColor: formSettings.cor_principal }"
                width="250"
                :src="formSettings.logo_footer"
                alt="Logo Footer"
            >
          </label>
          <div
              class="col-12 mt-2 d-flex justify-content-center"
              style="gap: 10px"
          >

            <b-button
                variant="danger"
                @click="deleteLogo('footer')"
            >
              Delete
            </b-button>
          </div>

        </b-card-body>
      </b-card>
    </div>

  </div>
</template>

<style scoped>

</style>
